import { createRouter, createWebHistory } from 'vue-router'
import rawRoutes from '~pages'
import { useTheme } from '../composables/useTheme'
import { usePostHog } from '@/composables/usePostHog'
import { i18n } from '@/i18n-setup'
import { buildLocalizedRoutes, buildFallbackRedirects } from '@/router/localized'

// PostHogをルーター作成前に初期化
usePostHog()

const localized = buildLocalizedRoutes(rawRoutes)
const fallback = buildFallbackRedirects(rawRoutes)

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // Localized routes only
    ...localized,
    // Redirect bare root to /ja (client-side 302; server should enforce 301)
    { path: '/', redirect: '/ja' },
    // Non-localized fallbacks -> current locale
    ...fallback,
  ],
})

// テーマ管理のグローバルインスタンス
const themeInstance = useTheme()

// ダッシュボードのテーマ状態を保存する変数
let dashboardThemeState = null

// ダッシュボードから離脱時にライトモードに変更
router.beforeEach((to, _from, next) => {
  // ダッシュボードページから他のページへ移動する場合
  if (to.path === '/' || to.path === '/ja' || to.path === '/en') {
    // 現在のテーマ状態を保存
    dashboardThemeState = themeInstance.theme.value
    themeInstance.setTheme('light')
  }
  
  // TOPページからダッシュボードに戻る場合
  if ((/^\/(ja|en)\/dashboard/.test(to.path) || to.path.startsWith('/dashboard')) && dashboardThemeState) {
    // 保存されたテーマ状態を復元
    themeInstance.setTheme(dashboardThemeState)
  }
  
  // Locale prefix enforcement and locale sync
  const seg1 = to.path.split('/')[1] || ''
  const isLocalized = seg1 === 'ja' || seg1 === 'en'
  if (!isLocalized && to.path !== '/' && !to.path.startsWith('/blog')) {
    // Redirect any non-prefixed path to /ja/* preserving query/hash
    const newPath = to.path.startsWith('/') ? `/ja${to.path}` : `/ja/${to.path}`
    next({ path: newPath, query: to.query, hash: to.hash, replace: true })
    return
  }
  const newLocale = seg1 === 'en' ? 'en' : 'ja'
  if (i18n.global.locale !== newLocale) {
    i18n.global.locale = newLocale
  }

  next()
})

// カスタムプロパティを含むページビュートラッキング（オプション）
router.afterEach((to) => {
  // PostHogの自動トラッキングに加えて、追加のメタデータを送信する場合
  if (window.posthog) {
    window.posthog.capture('$pageview', {
      route_name: to.name,
      route_path: to.path,
      route_params: to.params,
    })
  }
})

export default router
